const SEARCH_STATIC_UPDATED = (state, sivi) => {
  state.sivi = sivi;
};

const SELECT_AFD_MESSAGES_UPDATED = (state, selectedAFDMessages) => {
  state.selectedAFDMessages = selectedAFDMessages;
};

const SELECT_CUSTOMER = (context, {
  selectedCustomerId,
  selectedCustomer,
  newCustomerData,
}) => {
  context.selectedCustomerId = selectedCustomerId;
  context.selectedCustomer = selectedCustomer;
  context.newCustomerData = newCustomerData;
};

const SET_CUSTOMER_POLICY_INFORMATION = (
  context,
  {
    linkOptions,
    currentPackages,
    packageMessageOptions,
  },
) => {
  context.linkOptions = linkOptions;
  context.currentPackages = currentPackages;
  context.packageMessageLinkOptions = packageMessageOptions;
};

const SET_CHOSEN_PACKAGE = (context, chosenPackageId) => {
  context.chosenPackage = chosenPackageId;
};
const SET_FOUND_CUSTOMERS = (context, foundCustomer) => {
  context.foundCustomers = foundCustomer;
};

const CLEAR_CHOSEN_PACKAGE = (context) => {
  context.chosenPackage = "";
};

const SET_SAVE_ATTACHMENTS = (context, {
  policyMessage,
  saveAttachments,
}) => {
  context.saveMessageAttachments[policyMessage.id] = saveAttachments;
};

const DELETE_UNPROCESSED_PACKAGE_MESSAGE = (context, messageId) => {
  context.paginatedUnprocessedPackageMessages
    .splice(context.paginatedUnprocessedPackageMessages
      .findIndex((x) => x.id === messageId), 1);
};

const DESELECT_ALL_UNPROCESSED_PACKAGE_MESSAGES = (context) => {
  context.selectedUnprocessedPackageMessages = [];
};

const DESELECT_UNPROCESSED_PACKAGE_MESSAGE = (context, messageId) => {
  context.selectedUnprocessedPackageMessages
    .splice(context.selectedUnprocessedPackageMessages
      .findIndex((x) => x.id === messageId), 1);
};

const DECREMENT_UNPROCESSED_PACKAGE_MESSAGE_COUNT = (context) => {
  context.unprocessedPackageMessageCount -= 1;
};

const SELECT_UNPROCESSED_PACKAGE_MESSAGE = (context, message) => {
  context.selectedUnprocessedPackageMessages.push(message);
};

const SET_FETCHING_PAGINATED_UNPROCESSED_PACKAGE_MESSAGES = (state, value) => {
  state.fetchingPaginatedUnprocessedPackageMessages = value;
};

const SET_PAGINATED_UNPROCESSED_PACKAGE_MESSAGES = (state, response) => {
  state.paginatedUnprocessedPackageMessagesCurrentRequestData = response;
  state.paginatedUnprocessedPackageMessages = response.data;
  state.unprocessedPackageMessageCount = response.meta.pagination.total;
};

const SET_PAGINATED_UNPROCESSED_PACKAGE_MESSAGES_ORDER = (context, order) => {
  context.paginatedUnprocessedPackageMessagesOrder = order;
  localStorage.setItem("paginated-unprocessed-package-messages-order", order);
};

const SET_PAGINATED_UNPROCESSED_PACKAGE_MESSAGES_ORDER_BY = (context, orderBy) => {
  context.paginatedUnprocessedPackageMessagesOrderBy = orderBy;
  localStorage.setItem("paginated-unprocessed-package-messages-order-by", orderBy);
};

const SET_PAGINATED_UNPROCESSED_PACKAGE_MESSAGES_PAGE = (context, page) => {
  context.paginatedUnprocessedPackageMessagesPage = page;
  localStorage.setItem("paginated-unprocessed-package-messages-page", page);
};

const SET_PAGINATED_UNPROCESSED_PACKAGE_MESSAGES_PER_PAGE = (context, perPage) => {
  context.paginatedUnprocessedPackageMessagesPerPage = perPage;
  localStorage.setItem("paginated-unprocessed-package-messages-per-page", perPage);
};

const DELETE_UNPROCESSED_POLICY_MESSAGE = (context, messageId) => {
  context.paginatedUnprocessedPolicyMessages
    .splice(context.paginatedUnprocessedPolicyMessages
      .findIndex((x) => x.id === messageId), 1);
};

const DESELECT_ALL_UNPROCESSED_POLICY_MESSAGES = (context) => {
  context.selectedUnprocessedPolicyMessages = [];
};

const DESELECT_UNPROCESSED_POLICY_MESSAGE = (context, messageId) => {
  context.selectedUnprocessedPolicyMessages
    .splice(context.selectedUnprocessedPolicyMessages
      .findIndex((x) => x.id === messageId), 1);
};

const DECREMENT_UNPROCESSED_POLICY_MESSAGE_COUNT = (context) => {
  context.unprocessedPolicyMessageCount -= 1;
};

const SELECT_UNPROCESSED_POLICY_MESSAGE = (context, message) => {
  context.selectedUnprocessedPolicyMessages.push(message);
};

const SET_FETCHING_PAGINATED_UNPROCESSED_POLICY_MESSAGES = (state, value) => {
  state.fetchingPaginatedUnprocessedPolicyMessages = value;
};

const SET_PAGINATED_UNPROCESSED_POLICY_MESSAGES = (state, response) => {
  state.paginatedUnprocessedPolicyMessagesCurrentRequestData = response;
  state.paginatedUnprocessedPolicyMessages = response.data;
  state.unprocessedPolicyMessageCount = response.meta.pagination.total;
};

const SET_PAGINATED_UNPROCESSED_POLICY_MESSAGES_ORDER = (context, order) => {
  context.paginatedUnprocessedPolicyMessagesOrder = order;
  localStorage.setItem("paginated-unprocessed-policy-messages-order", order);
};

const SET_PAGINATED_UNPROCESSED_POLICY_MESSAGES_ORDER_BY = (context, orderBy) => {
  context.paginatedUnprocessedPolicyMessagesOrderBy = orderBy;
  localStorage.setItem("paginated-unprocessed-policy-messages-order-by", orderBy);
};

const SET_PAGINATED_UNPROCESSED_POLICY_MESSAGES_PAGE = (context, page) => {
  context.paginatedUnprocessedPolicyMessagesPage = page;
  localStorage.setItem("paginated-unprocessed-policy-messages-page", page);
};

const SET_PAGINATED_UNPROCESSED_POLICY_MESSAGES_PER_PAGE = (context, perPage) => {
  context.paginatedUnprocessedPolicyMessagesPerPage = perPage;
  localStorage.setItem("paginated-unprocessed-policy-messages-per-page", perPage);
};

const SET_PACKAGE_MESSAGE_FILTERS = (context, filters) => {
  context.packageMessageFilters = filters;
  localStorage.setItem("package-message-filters", JSON.stringify(filters));
};

// At the moment we only use the cached agency filters
const INITIALISE_PACKAGE_MESSAGE_FILTERS = (context) => {
  if (typeof localStorage.getItem("package-message-filters") !== "undefined") {
    const filters = JSON.parse(localStorage.getItem("package-message-filters"));
    filters.customer = null;
    filters.date_range = {};
    context.packageMessageFilters = filters;
  }
};

const SET_POLICY_MESSAGE_FILTERS = (context, filters) => {
  context.policyMessageFilters = filters;
  localStorage.setItem("policy-message-filter", JSON.stringify(filters));
};

// At the moment we only use the cached agency filters
const INITIALISE_POLICY_MESSAGE_FILTERS = (context) => {
  if (typeof localStorage.getItem("policy-message-filter") !== "undefined") {
    const filters = JSON.parse(localStorage.getItem("policy-message-filter"));
    filters.customer = null;
    filters.date_range = {};
    context.policyMessageFilters = filters;
  }
};

export default {
  SEARCH_STATIC_UPDATED,
  SELECT_AFD_MESSAGES_UPDATED,
  SELECT_CUSTOMER,
  SET_CUSTOMER_POLICY_INFORMATION,
  SET_CHOSEN_PACKAGE,
  SET_FOUND_CUSTOMERS,
  CLEAR_CHOSEN_PACKAGE,
  SET_SAVE_ATTACHMENTS,

  DELETE_UNPROCESSED_PACKAGE_MESSAGE,
  DESELECT_ALL_UNPROCESSED_PACKAGE_MESSAGES,
  DESELECT_UNPROCESSED_PACKAGE_MESSAGE,
  DECREMENT_UNPROCESSED_PACKAGE_MESSAGE_COUNT,
  SELECT_UNPROCESSED_PACKAGE_MESSAGE,
  SET_FETCHING_PAGINATED_UNPROCESSED_PACKAGE_MESSAGES,
  SET_PAGINATED_UNPROCESSED_PACKAGE_MESSAGES,
  SET_PAGINATED_UNPROCESSED_PACKAGE_MESSAGES_ORDER,
  SET_PAGINATED_UNPROCESSED_PACKAGE_MESSAGES_ORDER_BY,
  SET_PAGINATED_UNPROCESSED_PACKAGE_MESSAGES_PAGE,
  SET_PAGINATED_UNPROCESSED_PACKAGE_MESSAGES_PER_PAGE,

  DELETE_UNPROCESSED_POLICY_MESSAGE,
  DESELECT_ALL_UNPROCESSED_POLICY_MESSAGES,
  DESELECT_UNPROCESSED_POLICY_MESSAGE,
  DECREMENT_UNPROCESSED_POLICY_MESSAGE_COUNT,
  SELECT_UNPROCESSED_POLICY_MESSAGE,
  SET_FETCHING_PAGINATED_UNPROCESSED_POLICY_MESSAGES,
  SET_PAGINATED_UNPROCESSED_POLICY_MESSAGES,
  SET_PAGINATED_UNPROCESSED_POLICY_MESSAGES_ORDER,
  SET_PAGINATED_UNPROCESSED_POLICY_MESSAGES_ORDER_BY,
  SET_PAGINATED_UNPROCESSED_POLICY_MESSAGES_PAGE,
  SET_PAGINATED_UNPROCESSED_POLICY_MESSAGES_PER_PAGE,

  SET_PACKAGE_MESSAGE_FILTERS,
  INITIALISE_PACKAGE_MESSAGE_FILTERS,
  SET_POLICY_MESSAGE_FILTERS,
  INITIALISE_POLICY_MESSAGE_FILTERS,
};
